export default function stringToTitleCase(string?: string) {
  return string
    ?.toLowerCase()
    ?.split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.substring(1))
    .join(" ");
}


export const stringToTitleCaseWithUnderscore = (string?: string)=>
    string
        ?.toLowerCase()
        ?.split('_')
        .map(word => word.charAt(0).toUpperCase() + word.substring(1))
        .join(" ");